<template>
    <div class="column">
    <h5>
        {{ quote.product }} Personalised Finance Quotation
        
        <a :href="financeVideo" v-if="financeVideo" target="_blank">
            Why choose {{ quote.product }}?
        </a>
    </h5>

    <table>
        <tr v-for="item in financeExample">
            <th>{{ item.label }}:</th>
            <td>{{ item.value }}</td>
        </tr>
    </table>
</div> <!-- / column -->
</template>

<script>
export default {
    props: {
        quote: {
            type: Object,
            default: () => {}
        },
    },
    methods: {
        formatCurrency(value, currency = 'GBP', options = {}) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency,
                maximumFractionDigits: 2,
                ...options,
            }).format(value)
        }
    },
    computed: {
        financeVideo() {
            if (this.quote.product === 'PCP') {
                return '/sites/petervardy/templates/ajax/finance-videos.php?pcp=true'
            }

            if (this.quote.product === 'HP') {
                return '/sites/petervardy/templates/ajax/finance-videos.php?hp=true' 
            }

            return null
        },
        financeExample() {
            const formatCurrencyLong = (value) => this.formatCurrency(value, 'GBP', { maximumFractionDigits: 2 })

            if (typeof this.quote === 'object' && this.quote !== null) {
                const result = []

                if (this.quote.number_of_payments > 0 && this.quote.monthly_price > 0) {
                    result.push({
                        key: 'numberOfPayments',
                        label: this.quote.number_of_payments + ' monthly payments of',
                        value: formatCurrencyLong(this.quote.monthly_price),
                    })
                }

                if (this.quote.first_payment > 0) {
                    result.push({
                        key: 'firstMonthlyPayment',
                        label: 'First monthly payment',
                        value: formatCurrencyLong(this.quote.first_payment),
                    })
                }

                if (this.quote.final_payment > 0) {
                    result.push({
                        key: 'finalPayment',
                        label: 'Final payment',
                        value: formatCurrencyLong(this.quote.final_payment),
                    })
                }

                if (this.quote.cash_price > 0) {
                    result.push({
                        key: 'cashPrice',
                        label: 'Cash price',
                        value: formatCurrencyLong(this.quote.cash_price),
                    })
                }

                if (this.quote.dealer_deposit > 0) {
                    result.push({
                        key: 'dealerDeposit',
                        label: 'Peter Vardy Dealer Contribution Deposit',
                        value: formatCurrencyLong(this.quote.dealer_deposit),
                    })
                }

                if (this.quote.customer_deposit > 0) {
                    result.push({
                        key: 'customerDeposit',
                        label: 'Customer deposit',
                        value: formatCurrencyLong(this.quote.customer_deposit),
                    })
                }

                if (this.quote.total_deposit > 0) {
                    result.push({
                        key: 'totalDeposit',
                        label: 'Total deposit',
                        value: formatCurrencyLong(this.quote.total_deposit),
                    })
                }

                if (this.quote.total_credit_amount > 0) {
                    result.push({
                        key: 'totalCreditAmount',
                        label: 'Amount of credit',
                        value: formatCurrencyLong(this.quote.total_credit_amount),
                    })
                }

                if (this.quote.payable_amount > 0) {
                    result.push({
                        key: 'totalPayableAmount',
                        label: 'Total amount payable',
                        value: formatCurrencyLong(this.quote.payable_amount),
                    })
                }

                if (this.quote.option_to_purchase_fee) {
                    result.push({
                        key: 'optionToPurchaseFee',
                        label: 'Option to purchase fee',
                        value: formatCurrencyLong(this.quote.option_to_purchase_fee),
                    })
                }

                if (this.quote.documentation_fee) {
                    result.push({
                        key: 'documentationFee',
                        label: 'Documentation fee',
                        value: formatCurrencyLong(this.quote.documentation_fee),
                    })
                }

                if (this.quote.interest_rate > 0) {
                    result.push({
                        key: 'interestRate',
                        label: 'Rate of interest',
                        value: this.quote.interest_rate + '%',
                    })
                }

                if (this.quote.apr > 0) {
                    result.push({
                        key: 'apr',
                        label: 'APR',
                        value: this.quote.apr + '%',
                    })
                }

                return result
            }

            return null
        }
    }
}
</script>
